import { createSelector } from '@reduxjs/toolkit';
import {
  contactsAdapterSelectors,
  conversationsAdapterSelectors,
  participantsAdapterSelectors,
} from 'src/redux/slices/chat';

const selectConversations = createSelector(
  [
    (state) =>
      conversationsAdapterSelectors.selectAll(state.chat.conversations),
    (state) =>
      participantsAdapterSelectors.selectEntities(state.chat.participants),
  ],
  (conversations, participants) =>
    conversations
      .filter((conversation) => !conversation.finished)
      .map((conversation) => ({
        ...conversation,
        participants: conversation.participants.map(
          (user) => participants[user]
        ),
      }))
      .sort((a, b) =>
        b.messages[b.messages.length - 1]?.createdAt.localeCompare(
          a.messages[a.messages.length - 1]?.createdAt
        )
      )
);

const selectContacts = createSelector(
  [
    (state) => contactsAdapterSelectors.selectAll(state.chat.contacts),
    (state) => state.user.id,
  ],
  (contacts, currentUser) => contacts.filter((user) => user.id !== currentUser)
);

export const selectCurrentChatData = createSelector(
  selectConversations,
  selectContacts,
  (state) => state.user,
  (state) => state.chat,
  (conversations, contacts, user, chatState) => ({
    ...chatState,
    conversations,
    contacts,
    user,
  })
);
